import * as mutationTypes from "../../store/mutation-types.js";
import * as types from "../../store/mutation-types.js";
import * as globalMutationTypes from "@/store/mutation-types.js";
import globalStore from "@/store/index.js";

import basicOperations from "@/mixins/basic-operations.js";
import dateOperations from "@/mixins/date-operations.js";
import icons from "@/mixins/icons.js";
import _ from "lodash";
import DropdownInPlace from "@/components/utils/dropdown-in-place/dropdown-in-place.vue";
import Vue from 'vue';
// import { extend } from '@syncfusion/ej2-base';
import { L10n, loadCldr, setCulture, extend, Internationalization, Browser } from '@syncfusion/ej2-base';
// import { SchedulePlugin, Day, Week, WorkWeek, Month } from '@syncfusion/ej2-vue-schedule';
// import { SchedulePlugin, Day, Week, WorkWeek, Month, Agenda } from '@syncfusion/ej2-vue-schedule';
import { SchedulePlugin, Day, Week, WorkWeek, Month, View, Resize, DragAndDrop, Agenda } from "@syncfusion/ej2-vue-schedule";

// import * as localeText from "../../../../../src/locale.json";
import * as numberingSystems from "cldr-data/supplemental/numberingSystems.json";
import * as gregorian from "cldr-data/main/nl/ca-gregorian.json";
import * as numbers from "cldr-data/main/nl/numbers.json";
import * as timeZoneNames from "cldr-data/main/nl/timeZoneNames.json";

L10n.load({
  "nl": {
    "schedule": {
      "day": "Dag",
      "week": "Week",
      "workWeek": "Werkweek",
      "month": "Maand",
      "agenda": "Agenda",
      "weekAgenda": "Weekagenda",
      "workWeekAgenda": "Werkweek Agenda",
      "monthAgenda": "Maandagenda",
      "today": "Vandaag",
      "noEvents": "",
      "emptyContainer": "Er zijn geen lessen gepland op deze dag.",
      "allDay": "De hele dag",
      "start": "Begin",
      "end": "Einde",
      "more": "meer",
      "close": "Sluiten",
      "cancel": "annuleren",
      "noTitle": "(Geen titel)",
      "delete": "Delete",
      "deleteEvent": "Evenement verwijderen",
      "deleteMultipleEvent": "Verwijder meerdere evenementen",
      "selectedItems": "Items geselecteerd",
      "deleteSeries": "Serie verwijderen",
      "edit": "Bewerk",
      "editSeries": "Serie bewerken",
      "editEvent": "Evenement bewerken",
      "createEvent": "creëren",
      "subject": "Onderwerpen",
      "addTitle": "Titel toevoegen",
      "moreDetails": "Meer details",
      "save": "Opslaan",
      "editContent": "Wil je alleen dit evenement of deze hele serie bewerken?",
      "deleteRecurrenceContent": "Wil je alleen dit evenement of deze hele serie verwijderen?",
      "deleteContent": "Weet je zeker dat je dit evenement wilt verwijderen?",
      "deleteMultipleContent": "Weet je zeker dat je de geselecteerde evenementen wilt verwijderen?",
      "newEvent": "Nieuw evenement",
      "title": "Titel",
      "location": "Locatie",
      "description": "Omschrijving",
      "timezone": "Tijdzone",
      "startTimezone": "Start Tijdzone",
      "endTimezone": "Einde tijdzone",
      "repeat": "Herhaling",
      "saveButton": "Opslaan",
      "cancelButton": "annuleren",
      "deleteButton": "Delete",
      "recurrence": "Herhaling",
      "wrongPattern": "Het herhalingspatroon is niet geldig.",
      "seriesChangeAlert": "De wijzigingen die zijn aangebracht in specifieke exemplaren van deze serie worden geannuleerd en die evenementen komen weer overeen met de serie.",
      "createError": "De duur van het evenement moet korter zijn dan hoe vaak het voorkomt. Kort de duur in of wijzig het terugkeerpatroon in de terugkeereditor.",
      "recurrenceDateValidation": "Sommige maanden hebben minder dan de geselecteerde datum. Voor deze maanden valt het voorval op de laatste datum van de maand.",
      "sameDayAlert": "Twee gebeurtenissen van dezelfde gebeurtenis kunnen niet op dezelfde dag plaatsvinden.",
      "editRecurrence": "Herhaling bewerken",
      "repeats": "herhalingen",
      "alert": "alarm",
      "startEndError": "De geselecteerde einddatum vindt plaats vóór de startdatum.",
      "invalidDateError": "De ingevoerde datumwaarde is ongeldig.",
      "ok": "OK",
      "occurrence": "voorval",
      "series": "Serie",
      "previous": "voorgaand",
      "next": "volgende",
      "timelineDay": "Tijdlijn dag",
      "timelineWeek": "Tijdlijn Week",
      "timelineWorkWeek": "Tijdlijn Werkweek",
      "timelineMonth": "Tijdlijn maand"
    },
    "recurrenceeditor": {
      "none": "Geen",
      "daily": "Dagelijks",
      "weekly": "Wekelijks",
      "monthly": "Maandelijks",
      "month": "Maand",
      "yearly": "jaar-",
      "never": "Nooit",
      "until": "Tot",
      "count": "tellen",
      "first": "Eerste",
      "second": "Tweede",
      "third": "Derde",
      "fourth": "Vierde",
      "last": "Laatste",
      "repeat": "Herhaling",
      "repeatEvery": "Herhaal elke",
      "on": "Herhaal Aan",
      "end": "Einde",
      "onDay": "Dag",
      "days": "Dag (en)",
      "weeks": "Weken)",
      "months": "Maanden)",
      "years": "Jaar (s)",
      "every": "elk",
      "summaryTimes": "keer)",
      "summaryOn": "Aan",
      "summaryUntil": "tot",
      "summaryRepeat": "herhalingen",
      "summaryDay": "dag (en)",
      "summaryWeek": "weken)",
      "summaryMonth": "maanden)",
      "summaryYear": "jaar (jaren)",
      "monthWeek": "Maand Week",
      "monthPosition": "Maandpositie",
      "monthExpander": "Maanduitbreiding",
      "yearExpander": "Jaaruitbreiding",
      "repeatInterval": "Herhaal interval"
    },
    "calendar": {
      "today": "Vandaag"
    }
  }
})
loadCldr(
  require('cldr-data/supplemental/numberingSystems.json'),
  require('cldr-data/main/nl/ca-gregorian.json'),
  require('cldr-data/main/nl/numbers.json'),
  require('cldr-data/main/nl/timeZoneNames.json')
);
let instance = new Internationalization();
// let footerTemplateVue = Vue.component('footerTemplate', { //Show this if want to customize the default footer with buttons.
//   template: `<div ></div>`,
//   data() {
//     return {
//       data: {}
//     };
//   }
// });
let agendaTemplateVue = Vue.component('agendaTemplate', {
  template: `<div class="template-wrap" ><div style='font-size:14px'class="subject">{{data.Subject}}</div>
  <div style='font-size:14px'class="location e-location pl-0"> {{data.LokaalOmschrijving}} Lokaal {{data.LokaalCode}} <br> 
   {{data.LesPlaatsOmschrijving}}<div class='mt-1'>  {{data.LesPlaatsStraat}}  {{data.LesPlaatsStraatNr}}  {{data.LesPlaatsStraatBus}} 
    <br>{{data.LesPlaatsDeelgemeente}} </div> <div class='mt-1'>{{getTimeString(data.StartTime)}} - {{getTimeString(data.EndTime)}} </div></div>
  </div>`,
  data() {
    return {
      data: {}
    }
  },
  methods: {
    getTimeString: function (value) {
      return instance.formatDate(value, { skeleton: "Hm" });
    },
  }

})
export default {
  data() {
    return {
      emptyAgendaDays: true,
      earliestHour: this.$store.state.wstudent.earliestHour,
      latestHour: this.$store.state.wstudent.latestHour,
      scheduleHeight: 'calc(100vh - 70px)',
      // participationList: this.$store.state.wstudent.participationList,
      selectedDate: new Date(),
      eventTemplate: function (e) {
        return {
          template: agendaTemplateVue
        }
      },
      // quickInfoTemplates: { //This also works for customization of header,content (must add in html   :quickInfoTemplates='quickInfoTemplates) https://ej2.syncfusion.com/vue/documentation/schedule/editor-template/
      //   footer: function (e) {
      //     return {
      //       template: footerTemplateVue
      //     };
      //   }
      // },
      locale: "nl",
      // eventSettings: { dataSource: extend([], readonlyEventsData, null, true) },
      eventSettings: { dataSource: extend([], this.$store.state.wstudent.participationListCalendar, null, true) },
      currentView: 'Agenda'

    };
  },
  provide: {
    schedule: [Day, Week, WorkWeek, Month, Resize, DragAndDrop, Agenda]
  },

  beforeCreate: function () {
    let veranderpaswoord = this.$store.state.userInfo.loggedInUserInformation.UserData.veranderpaswoord;
    // eslint-disable-next-line
    if (Object.keys(WISA).length === 0 || veranderpaswoord || veranderpaswoord === undefined) {
      this.$router.push("/"); //uncomment this
    }
  },
  beforeRouteLeave(to, from, next) {
    $('body').css('overflow', '');
    $('body').css('margin-top', ' 4rem');
    next();
  },
  computed: {
    // scheduleHeight() {
    //   if (this.isMobile()) {
    //     return 'calc(100vh - 70px)'
    //   } else {
    //     return 'calc(100vh - 70px)'
    //   }
    // }
  },
  created: function () {

    let self = this
    // globalStore.dispatch("wstudent/" + "getAccountInfo");

    this.$store.commit("wstudent/" + types.ZET_CURRENT_SCREEN, "Agenda");

  },
  mounted: function () {
    let self = this;
    this.$store.commit(globalMutationTypes.SET_MENUBAR_ITEMS, {
      changePartially: true,
      left: "menu",
      // title: titelWaarde,
      title: "Agenda",
      right: []
    });

    $('body').css('overflow', 'hidden');
    $('body').css('margin-top', '3rem');

  },
  updated: function () { },
  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    onPopupOpen: function (args) {
      if ((args.type === 'QuickInfo' || args.type === 'Editor') && !args.target.classList.contains('e-appointment')) {
        args.cancel = this.onEventCheck(args);
      }
    },
    onActionBegin(args) {
      if ((args.requestType === 'eventCreate') || args.requestType === 'eventChange') {
        args.cancel = this.onEventCheck(args);
      }
    },
    onDragStop(args) {
      args.cancel = this.onEventCheck(args);
    },
    onResizeStop(args) {
      args.cancel = this.onEventCheck(args);
    },
    onEventCheck(args) {
      var eventObj = args.data instanceof Array ? args.data[0] : args.data;
      return (new Date());
    }
  }
}
